import React, { useState } from "react";
import { Box, type BoxProps } from "@chakra-ui/react";
import { type FormProps, HubSpotForm } from "components/hubspot";
import { trackDemoFormSubmitted } from "components/event-tracking";
import { DemoSuccessContent } from "./demo-success-content";

type DemoFormProps = {
  /**
   *  Chili Piper router name.
   * @default "inbound-router"
   */
  chiliPiperRouterName?: string;
  /** Callback function when the form is submitted. */
  onSubmit?: () => void;
} & Pick<FormProps, "enableAutoComplete" | "hideDisabledState">;

export function DemoForm({
  hideDisabledState,
  enableAutoComplete,
  chiliPiperRouterName = "inbound-router",
  onSubmit,
  ...props
}: DemoFormProps & BoxProps) {
  const [success, setSuccess] = useState<boolean>(false);
  const [isPrivateBrowser, setIsPrivateBrowser] = useState<boolean>(false);

  const onFormSubmit = (lead: Record<string, string>) => {
    const cpTenantDomain = "hightouch";

    trackDemoFormSubmitted(lead);

    // Call the onSubmit handler before the Chili Piper modal launches
    onSubmit?.();

    if (window.ChiliPiper) {
      window.ChiliPiper.submit?.(cpTenantDomain, chiliPiperRouterName, {
        map: true,
        lead,
        onSuccess() {
          setSuccess(true);
        },
        onError() {
          // Show the success modal even if ChiliPiper errors because the lead is still created.
          setSuccess(true);
        },
      });
    } else {
      // IF CP does not load (ex. private safari windows),
      // we still show the success content to let the user know we have received their request through Hubspot
      setSuccess(true);
      setIsPrivateBrowser(true);
    }
  };

  return (
    <Box {...props}>
      <HubSpotForm
        label="Book a demo"
        formId="6ba03127-8b95-400c-a229-c5fb099d929f"
        sfdcCampaignId="7015e0000010D1QAAU"
        enableAutoComplete={enableAutoComplete}
        hideDisabledState={hideDisabledState}
        successContent={success && <DemoSuccessContent isPrivateBrowser={isPrivateBrowser} />}
        onSubmit={onFormSubmit}
      />
    </Box>
  );
}
